import type { ApiGenericResponse, Service } from '../../typings'

export function getServiceByIdAction<T = ApiGenericResponse<Service>>(slug: string): Promise<T> {
  const { api } = useApi()
  return api.get<T>(`/v2/services/${slug}`)
}
